module.exports = "img/plantando.cde4fd.webm";